import type { CoinsToBalance, CoinType } from "../../packages/coin/coinTypes";
import type { AftermathApi } from "../providers/aftermathApi";
import type { SuiAddress, TransactionDigest } from "../types";
import { Helpers } from "../utils/helpers";

export class WalletApi {
	// =========================================================================
	//  Constructor
	// =========================================================================

	constructor(private readonly api: AftermathApi) {}

	// =========================================================================
	//  Fetching
	// =========================================================================

	// =========================================================================
	//  Coins
	// =========================================================================

	public fetchCoinBalance = async (inputs: {
		walletAddress: SuiAddress;
		coin: CoinType;
	}) => {
		const { walletAddress, coin } = inputs;
		const coinBalance = await this.api.client.getBalance({
			owner: walletAddress,
			coinType: Helpers.stripLeadingZeroesFromType(coin),
		});
		return BigInt(coinBalance.totalBalance);
	};

	// TODO: make toBigIntSafe function ?
	// TODO: return prices here as well and sort ?
	public fetchAllCoinBalances = async (inputs: {
		walletAddress: SuiAddress;
	}): Promise<CoinsToBalance> => {
		const { walletAddress } = inputs;

		const allBalances = await this.api.client.getAllBalances({
			owner: walletAddress,
		});

		const coinsToBalance: CoinsToBalance = allBalances.reduce(
			(acc, balance) => {
				return {
					...acc,
					[Helpers.addLeadingZeroesToType(balance.coinType)]: BigInt(
						balance.totalBalance
					),
				};
			},
			{}
		);

		return coinsToBalance;
	};

	// =========================================================================
	//  Transactions
	// =========================================================================

	// TODO: make this only look at aftermath relevant addresses in to address
	// TODO: restrict all filtering for events, etc. similarly using updated sdk filters
	public fetchPastTransactions = async (inputs: {
		walletAddress: SuiAddress;
		cursor?: TransactionDigest;
		limit?: number;
	}) => {
		const { walletAddress, cursor, limit } = inputs;

		const transactionsWithCursor = await this.api
			.Transactions()
			.fetchTransactionsWithCursor({
				query: {
					filter: {
						FromAddress: walletAddress,
					},
				},
				cursor,
				limit,
			});

		return transactionsWithCursor;
	};
}
